/**
 * Sanitize user input to prevent XSS attacks
 * Simple implementation without DOMPurify dependency for this project
 */
export const sanitizeInput = (input: string): string => {
    return input
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#x27;')
      .replace(/\//g, '&#x2F;')
      .trim()
  }
  
  export const sanitizeURL = (url: string): string => {
    try {
      const parsed = new URL(url)
      if (!['http:', 'https:'].includes(parsed.protocol)) return ''
      return url
    } catch {
      return ''
    }
  }